import { useContext } from 'react';
import Compare from '../Compare';
import Stack from '../../../shared/layouts/Stack';
import Box from '../../../shared/layouts/Box';
import CategoryHeader from '../CategoryHeader';
import { CompareContext } from '../ComparePage';
import {useTranslation} from "react-i18next";

const SECTION = 'applicant_contact';

const CompareContactSection = () => {
  const {
    // ownAddressData,
    // otherAddressData,
    ownApplicantData,
    otherApplicantData,
    handleApplicantDataChange,
    showOnlyDiff,
    hasDiff,
    shouldShow,
    contactInfoFields,
    hasSectionCopiedFields,
  } = useContext(CompareContext);

  const { t } = useTranslation();

  const handleDataChange = (e) => {
    handleApplicantDataChange(e, SECTION);
  };

  if (
    showOnlyDiff &&
    !hasSectionCopiedFields(SECTION) &&
    !hasDiff(contactInfoFields,
      { ...ownApplicantData, /*...ownAddressData*/},
      { ...otherApplicantData, /*...otherAddressData*/ }
    )
  ) {
    return null;
  }

  return (
    <Stack space="l">
      <CategoryHeader>
        <span>{t('Contactgegevens')}</span>
        <span>{t('Contactgegevens')}</span>
      </CategoryHeader>
      <Stack space="m">
        {/*{shouldShow(*/}
        {/*  ['zipcode', 'housenumber', 'housenumber_addition'],*/}
        {/*  ownAddressData,*/}
        {/*  otherAddressData*/}
        {/*) && (*/}
        {/*  <Compare*/}
        {/*    label={t("Postcode, huisnummer en toevoeging")}*/}
        {/*    name="mixed"*/}
        {/*    leftValue={[*/}
        {/*      ownAddressData.zipcode,*/}
        {/*      ownAddressData.housenumber,*/}
        {/*      ownAddressData.housenumber_addition,*/}
        {/*    ]}*/}
        {/*    rightValue={[*/}
        {/*      otherAddressData.zipcode,*/}
        {/*      otherAddressData.housenumber,*/}
        {/*      otherAddressData.housenumber_addition,*/}
        {/*    ]}*/}
        {/*    onUpdate={(e) => {*/}
        {/*      const [*/}
        {/*        zipcode,*/}
        {/*        housenumber,*/}
        {/*        housenumber_addition,*/}
        {/*      ] = e.target.value;*/}
        {/*      setOwnAddressData({ zipcode, housenumber, housenumber_addition });*/}
        {/*    }}*/}
        {/*  />*/}
        {/*)}*/}
        {/*{shouldShow('street', ownAddressData, otherAddressData) && (*/}
        {/*  <Compare*/}
        {/*    label={t("Straatnaam")}*/}
        {/*    name="street"*/}
        {/*    leftValue={ownAddressData.street}*/}
        {/*    rightValue={otherAddressData.street}*/}
        {/*    onUpdate={handleAddressDataChange}*/}
        {/*  />*/}
        {/*)}*/}
        {/*{shouldShow('place', ownAddressData, otherAddressData) && (*/}
        {/*  <Compare*/}
        {/*    label={t("Plaatsnaam")}*/}
        {/*    name="place"*/}
        {/*    leftValue={ownAddressData.place}*/}
        {/*    rightValue={otherAddressData.place}*/}
        {/*    onUpdate={handleAddressDataChange}*/}
        {/*  />*/}
        {/*)}*/}
        {shouldShow(
          'phone_number',
          ownApplicantData,
          otherApplicantData,
          SECTION
        ) && (
          <Compare
            label={t("Telefoonnummer")}
            name="phone_number"
            section={SECTION}
            leftValue={ownApplicantData?.phone_number}
            rightValue={otherApplicantData?.phone_number}
            onUpdate={handleDataChange}
          />
        )}
        {shouldShow('email', ownApplicantData, otherApplicantData, SECTION) && (
          <Box css={{ overflowWrap: 'anywhere' }}>
            <Compare
              label={t("Emailadres")}
              name="email"
              section={SECTION}
              leftValue={ownApplicantData?.email}
              rightValue={otherApplicantData?.email}
              onUpdate={handleDataChange}
            />
          </Box>
        )}
      </Stack>
    </Stack>
  );
};

export default CompareContactSection;
